module.exports = __webpack_public_path__ + "img/firts-portfolio.d521b0c4.png";